import { useState, useEffect, createContext } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { authAPI } from '../apis/authAPI';
import SignInModal from '../components/Modals/SignInModal/SignInModal';

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [connected, setConnected] = useState(false);
	const [authenticated, setAuthenticated] = useState(false);
	const [user, setUser] = useState(null);
	const [isSigninOpen, setSigninOpen] = useState(false);
	const navigate = useNavigate();

	useEffect(() => {
		// Connection and user state
		authAPI.connect().then((resp) => {
			//console.log(resp);
			if (resp) {
				setAuthenticated(resp.authenticated);
				setConnected(resp.connected);
				setUser(resp.user);
			}
		});
	}, []);

	const signin = () => {
		setSigninOpen(true);
	};

	const signout = () => {
		authAPI.logout().then(() => {
			authAPI.connect().then((resp) => {
				if (resp) {
					//console.log(resp);
					setAuthenticated(resp.authenticated);
					setConnected(resp.connected);
					setUser(resp.user);
					navigate('/');
				}
			});
		});
	};

	const handleRequestClose = () => {
		setSigninOpen(false);
	};

	const value = {
		connected,
		authenticated,
		user,
		signin,
		signout,
	};

	return (
		<AuthContext.Provider value={value}>
			{children}
			<SignInModal isOpen={isSigninOpen} onRequestClose={handleRequestClose} />
		</AuthContext.Provider>
	);
};

AuthProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
